// Props for wrap-with-hint.vue and icon-hint.vue
export default {
  content: { type: String, required: false },
  interactive: { type: Boolean, default: false },

  /* These usually don't need to be overridden */
  allowHTML: { type: Boolean, default: true },
  theme: { type: String, default: "recipal" },
  trigger: { type: String, default: "mouseenter focus click" },
  appendTo: { type: [String, Element], default: () => document.body },
};
